(ns common.schema.entities.login-page-config
  (:require
   [common.schema.constraints :as constraints]
   [common.schema.schema-utils :as su]))

(defn get-max-number-of-login-page-configs
  [tenant]
  (get tenant :tenant/max-number-of-login-page-configs 1))

(def sso-login-methods-options
  [{:key   :azure
    :value :azure
    :label "Azure"}
   {:key   :saml
    :value :saml
    :label "SAML"}])

(def schema
  (vec
   (concat
    ;; Basic identification
    (su/name-unique-per-tenant :login-page-config/name
                               "Name"
                               :entity.type/login-page-config
                               {:authorization su/access-admin-admin})

    ;; Is this zadmin or admin??
    (su/text-unique-global :login-page-config/path
                           "Login path"
                           {:authorization su/access-admin-admin
                            :constraints   {:constraint/valid-string-value
                                            {:validation-fn constraints/validate-sso-login-path}}})

    ;; Azure SSO Configuration
    (su/boolean-field :login-page-config/use-custom-azure-sso-application?
                      "Use custom Azure SSO application?"
                      {:authorization su/access-admin-admin})

    (su/text-simple-field :login-page-config/azure-sso-tenant-id
                          "Azure SSO tenant ID"
                          {:authorization su/access-admin-admin})

    (su/text-simple-field :login-page-config/azure-sso-client-secret
                          "Azure SSO client secret"
                          {:authorization su/access-admin-system})

    (su/text-simple-field :login-page-config/azure-sso-client-id
                          "Azure SSO client ID"
                          {:authorization su/access-admin-admin})

    (su/text-simple-field :login-page-config/azure-sso-authority
                          "Azure SSO authority"
                          {:authorization su/access-admin-admin})

    (su/text-simple-field :login-page-config/azure-sso-scope
                          "Azure SSO scope"
                          {:authorization su/access-admin-admin})

    ;; SAML Configuration
    (su/url-field :login-page-config/saml-idp-post-url
                  "IDP post URL"
                  {:authorization su/access-admin-admin})

    (su/url-field :login-page-config/saml-idp-redirect-url
                  "IDP redirect URL"
                  {:authorization su/access-admin-admin})

    (su/url-field :login-page-config/saml-idp-logout-url
                  "IDP logout URL"
                  {:authorization su/access-admin-admin})

    (su/text-simple-field :login-page-config/saml-idp-entity-id
                          "IDP entity ID"
                          {:authorization su/access-admin-admin})

    (su/text-multiline-field :login-page-config/saml-idp-public-key
                             "IDP public key"
                             {:authorization su/access-admin-admin})

    (su/keyword-multi-field :login-page-config/sso-login-methods
                            "SSO login methods"
                            sso-login-methods-options
                            {:authorization su/access-admin-user})

    (su/text-simple-field :login-page-config/logo-url
                          "Logo URL"
                          {:authorization su/access-admin-user})

    (su/text-simple-field :login-page-config/banner-img-url
                          "Banner image URL"
                          {:authorization su/access-admin-user})

    (su/text-simple-field :login-page-config/banner-img-xl-url
                          "Banner image URL (XL)"
                          {:authorization su/access-admin-user})

    (su/text-simple-field :login-page-config/button-background-color
                          "Button background color"
                          {:authorization su/access-admin-user})

    (su/text-simple-field :login-page-config/button-text-color
                          "Button text color"
                          {:authorization su/access-admin-user})

    (su/text-simple-field :login-page-config/button-text
                          "Button text"
                          {:authorization su/access-admin-user}))))
